/**
 * Temporary workarounds for React 19 compatibility with Apollo MockedProvider
 * and React Router components in tests.
 */
import {MockedProvider} from '@apollo/client/testing';
import {BrowserRouter} from 'react-router-dom';

export const MockedProviderCompat = MockedProvider as any;
export const BrowserRouterCompat = BrowserRouter as any;
